// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== BASE ========== */
body {
  font-family: "Poppins", sans-serif !important;
  background-color: #f4f6fb;
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ========== DASHBOARD LAYOUT ========== */
/* ========== DASHBOARD LAYOUT ========== */
/* Handled by Tailwind flex classes in App.js */

/* ========== SIDEBAR ========== */
/* ========== SIDEBAR ========== */
/* Most sidebar styles are now managed via Tailwind in sidebar.js */
.sidebar-nav-area::-webkit-scrollbar {
  width: 4px;
}

.sidebar-nav-area::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav-area::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

/* ========== MAIN CONTENT ========== */
/* ========== MAIN CONTENT ========== */
/* Handled by flex-1 in App.js */

/* ========== NAVBAR ========== */
/* ========== NAVBAR ========== */
/* Navbar styling is now largely in navbar.js using Tailwind */

/* ========== PAGE CONTENT ========== */
/* ========== PAGE CONTENT ========== */
.page-content {
  padding-bottom: 40px;
}

/* ========== ACCORDION OVERHAUL ========== */
.accordion {
  border: none !important;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.accordion-item {
  border: 1px solid #e8ecf3 !important;
  border-radius: 12px !important;
  overflow: hidden;
  background: #fff;
  transition: box-shadow 0.25s ease, border-color 0.25s ease;
}

.accordion-item:hover {
  border-color: #d0d5e0 !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.accordion-button {
  padding: 16px 20px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #2c2c3e !important;
  background: #fff !important;
  border: none !important;
  box-shadow: none !important;
  gap: 12px;
  transition: background 0.2s ease;
}

.accordion-button:hover {
  background: #f8f9fc !important;
}

.accordion-button:not(.collapsed) {
  background: linear-gradient(135deg, #1e1e5c 0%, #2a2a72 100%) !important;
  color: #fff !important;
  box-shadow: none !important;
}

.accordion-button:not(.collapsed)::after {
  filter: brightness(0) invert(1);
}

.accordion-button:focus {
  box-shadow: none !important;
}

.accordion-button::before {
  content: counter(accordion-counter);
  counter-increment: accordion-counter;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 8px;
  background: rgba(30, 30, 92, 0.08);
  color: #1e1e5c;
  font-size: 12px;
  font-weight: 700;
  transition: all 0.2s ease;
}

.accordion-button:not(.collapsed)::before {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

.accordion {
  counter-reset: accordion-counter;
}

.accordion-body {
  padding: 20px 24px !important;
  background: #fcfcfe;
  border-top: 1px solid #eef0f5;
}

/* Nested accordions reset counter */
.accordion-body .accordion {
  counter-reset: accordion-counter;
}

.accordion-body .accordion-item {
  border: 1px solid #e2e6ef !important;
  border-radius: 10px !important;
  background: #fff;
}

.accordion-body .accordion-button {
  padding: 12px 16px !important;
  font-size: 13px !important;
}

.accordion-body .accordion-button::before {
  width: 24px;
  height: 24px;
  min-width: 24px;
  font-size: 11px;
  border-radius: 6px;
}

/* ========== SAVE BUTTON BAR ========== */
/* ========== SAVE BUTTON BAR ========== */
.save-button-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-top: 1px solid #e8ecf3;
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.05);
}

@media (min-width: 1024px) {
  .save-button-bar {
    /* left: 260px; */
    /* Sidebar width */
  }
}

/* ========== LOGIN PAGE ========== */
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f0f3a 0%, #1e1e5c 50%, #2d1b69 100%);
  position: relative;
  overflow: hidden;
}

.login-page::before {
  content: "";
  position: absolute;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(252, 187, 50, 0.12) 0%, transparent 70%);
  top: -100px;
  right: -100px;
  pointer-events: none;
}

.login-page::after {
  content: "";
  position: absolute;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(124, 19, 202, 0.1) 0%, transparent 70%);
  bottom: -100px;
  left: -100px;
  pointer-events: none;
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 48px 40px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 1;
  animation: loginSlideUp 0.5s ease-out;
}

@keyframes loginSlideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-card .login-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}

.login-card .login-logo img {
  width: 70px;
  height: 70px;
  object-fit: contain;
  margin-bottom: 16px;
}

.login-card .login-logo h1 {
  font-size: 22px;
  font-weight: 700;
  color: #1e1e5c;
  margin-bottom: 4px;
  text-align: center;
}

.login-card .login-logo p {
  font-size: 13px;
  color: #888;
  margin: 0;
}

.login-card .form-label {
  font-size: 13px;
  font-weight: 600;
  color: #2c2c3e;
  margin-bottom: 6px;
}

.login-card .form-control {
  background: #f4f6fb !important;
  border: 1.5px solid #e0e4ed !important;
  border-radius: 10px !important;
  padding: 12px 16px;
  padding-left: 42px !important;
  /* Ensure enough space for icons by default */
  font-size: 14px !important;
  color: #2c2c3e !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
}

.login-card .form-control:focus {
  border-color: #1e1e5c !important;
  box-shadow: 0 0 0 3px rgba(30, 30, 92, 0.1) !important;
  background: #fff !important;
}

.login-card .form-control::placeholder {
  color: #aaa !important;
  font-size: 13px;
}

.login-card .login-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #1e1e5c 0%, #2a2a72 100%) !important;
  border: none !important;
  border-radius: 10px !important;
  color: #fff !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  cursor: pointer;
  transition: all 0.3s ease !important;
  position: relative;
  overflow: hidden;
}

.login-card .login-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(30, 30, 92, 0.35) !important;
}

.login-card .login-btn:active {
  transform: translateY(0);
}

/* ========== CUSTOM SCROLLBAR ========== */
.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
}

.custom-scrollbar:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
}

/* Sidebar scrollbar */
.sidebar .sidebar-nav-area::-webkit-scrollbar {
  width: 4px;
}

.sidebar .sidebar-nav-area::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar .sidebar-nav-area::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

/* ========== BUTTONS ========== */
.btn-primary-admin {
  background: linear-gradient(135deg, #1e1e5c 0%, #2a2a72 100%);
  border: none;
  border-radius: 10px;
  padding: 10px 24px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary-admin:hover {
  box-shadow: 0 4px 16px rgba(30, 30, 92, 0.3);
  transform: translateY(-1px);
}

.btn-accent {
  background: linear-gradient(135deg, #FCBB32 0%, #f5a623 100%);
  border: none;
  border-radius: 10px;
  padding: 10px 24px;
  color: #1e1e5c;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-accent:hover {
  box-shadow: 0 4px 16px rgba(252, 187, 50, 0.35);
  transform: translateY(-1px);
}

/* ========== FORM INPUT ENHANCEMENTS ========== */
.form-control {
  border-radius: 8px !important;
  border: 1.5px solid #e0e4ed !important;
  padding: 10px 14px !important;
  font-size: 13.5px !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
}

.form-control:focus {
  border-color: #1e1e5c !important;
  box-shadow: 0 0 0 3px rgba(30, 30, 92, 0.08) !important;
}

/* ========== TABLE ENHANCEMENTS ========== */
table {
  border-collapse: separate !important;
  border-spacing: 0;
  border-radius: 10px !important;
  overflow: hidden;
}

table thead {
  background: #f4f6fb !important;
}

table thead th {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #6b7280 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px 16px !important;
  border-bottom: 2px solid #e8ecf3 !important;
}

table tbody td {
  padding: 12px 16px !important;
  font-size: 13.5px;
  border-bottom: 1px solid #f0f2f7;
}

table tbody tr:last-child td {
  border-bottom: none;
}

table tbody tr:hover {
  background: #f8f9fc;
}

/* ========== POPPER / DROPDOWN ========== */
.navbar-profile-popper {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8ecf3;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  padding: 8px;
  min-width: 200px;
}

.navbar-profile-popper .profile-info {
  padding: 12px 14px;
  border-bottom: 1px solid #f0f2f7;
  margin-bottom: 4px;
}

.navbar-profile-popper .profile-info .profile-name {
  font-size: 14px;
  font-weight: 600;
  color: #2c2c3e;
}

.navbar-profile-popper .profile-info .profile-role {
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.navbar-profile-popper .logout-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  color: #FB325E;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
}

.navbar-profile-popper .logout-btn:hover {
  background: rgba(251, 50, 94, 0.06);
}

/* ========== USER AVATAR ========== */
.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #FCBB32 0%, #f5a623 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e1e5c;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: box-shadow 0.2s ease;
}

.user-avatar:hover {
  box-shadow: 0 0 0 3px rgba(252, 187, 50, 0.25);
}

/* ========== PAGE TITLE ========== */
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e1e5c;
  margin-bottom: 4px;
}

.page-subtitle {
  font-size: 13px;
  color: #888;
  margin-bottom: 20px;
}

/* ========== ANIMATION UTILITIES ========== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fadeIn 0.35s ease-out;
}

/* ========== RESPONSIVE ========== */
/* Managed by Tailwind's responsive prefixes (sm:, md:, lg:, xl:, etc.) */`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,SAAS;EACT,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,2CAA2C;AAC3C,2CAA2C;AAC3C,+CAA+C;;AAE/C,kCAAkC;AAClC,kCAAkC;AAClC,mEAAmE;AACnE;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC,uCAAuC;AACvC,gCAAgC;;AAEhC,iCAAiC;AACjC,iCAAiC;AACjC,8DAA8D;;AAE9D,uCAAuC;AACvC,uCAAuC;AACvC;EACE,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wEAAwE;EACxE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C,0CAA0C;AAC1C;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,cAAc;EACd,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8EAA8E;EAC9E,kBAAkB;EAClB,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,6CAA6C;EAC7C,0BAA0B;EAC1B,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wEAAwE;EACxE,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,6BAA6B;EAC7B,4BAA4B;EAC5B,mEAAmE;AACrE;;AAEA;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;EACpC,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;AAChD;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qCAAqC;AACrC,yEAAyE","sourcesContent":["/* ========== BASE ========== */\nbody {\n  font-family: \"Poppins\", sans-serif !important;\n  background-color: #f4f6fb;\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* ========== DASHBOARD LAYOUT ========== */\n/* ========== DASHBOARD LAYOUT ========== */\n/* Handled by Tailwind flex classes in App.js */\n\n/* ========== SIDEBAR ========== */\n/* ========== SIDEBAR ========== */\n/* Most sidebar styles are now managed via Tailwind in sidebar.js */\n.sidebar-nav-area::-webkit-scrollbar {\n  width: 4px;\n}\n\n.sidebar-nav-area::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-nav-area::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n}\n\n/* ========== MAIN CONTENT ========== */\n/* ========== MAIN CONTENT ========== */\n/* Handled by flex-1 in App.js */\n\n/* ========== NAVBAR ========== */\n/* ========== NAVBAR ========== */\n/* Navbar styling is now largely in navbar.js using Tailwind */\n\n/* ========== PAGE CONTENT ========== */\n/* ========== PAGE CONTENT ========== */\n.page-content {\n  padding-bottom: 40px;\n}\n\n/* ========== ACCORDION OVERHAUL ========== */\n.accordion {\n  border: none !important;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.accordion-item {\n  border: 1px solid #e8ecf3 !important;\n  border-radius: 12px !important;\n  overflow: hidden;\n  background: #fff;\n  transition: box-shadow 0.25s ease, border-color 0.25s ease;\n}\n\n.accordion-item:hover {\n  border-color: #d0d5e0 !important;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);\n}\n\n.accordion-button {\n  padding: 16px 20px !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: #2c2c3e !important;\n  background: #fff !important;\n  border: none !important;\n  box-shadow: none !important;\n  gap: 12px;\n  transition: background 0.2s ease;\n}\n\n.accordion-button:hover {\n  background: #f8f9fc !important;\n}\n\n.accordion-button:not(.collapsed) {\n  background: linear-gradient(135deg, #1e1e5c 0%, #2a2a72 100%) !important;\n  color: #fff !important;\n  box-shadow: none !important;\n}\n\n.accordion-button:not(.collapsed)::after {\n  filter: brightness(0) invert(1);\n}\n\n.accordion-button:focus {\n  box-shadow: none !important;\n}\n\n.accordion-button::before {\n  content: counter(accordion-counter);\n  counter-increment: accordion-counter;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  border-radius: 8px;\n  background: rgba(30, 30, 92, 0.08);\n  color: #1e1e5c;\n  font-size: 12px;\n  font-weight: 700;\n  transition: all 0.2s ease;\n}\n\n.accordion-button:not(.collapsed)::before {\n  background: rgba(255, 255, 255, 0.15);\n  color: #fff;\n}\n\n.accordion {\n  counter-reset: accordion-counter;\n}\n\n.accordion-body {\n  padding: 20px 24px !important;\n  background: #fcfcfe;\n  border-top: 1px solid #eef0f5;\n}\n\n/* Nested accordions reset counter */\n.accordion-body .accordion {\n  counter-reset: accordion-counter;\n}\n\n.accordion-body .accordion-item {\n  border: 1px solid #e2e6ef !important;\n  border-radius: 10px !important;\n  background: #fff;\n}\n\n.accordion-body .accordion-button {\n  padding: 12px 16px !important;\n  font-size: 13px !important;\n}\n\n.accordion-body .accordion-button::before {\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  font-size: 11px;\n  border-radius: 6px;\n}\n\n/* ========== SAVE BUTTON BAR ========== */\n/* ========== SAVE BUTTON BAR ========== */\n.save-button-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 999;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border-top: 1px solid #e8ecf3;\n  padding: 10px 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.05);\n}\n\n@media (min-width: 1024px) {\n  .save-button-bar {\n    /* left: 260px; */\n    /* Sidebar width */\n  }\n}\n\n/* ========== LOGIN PAGE ========== */\n.login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #0f0f3a 0%, #1e1e5c 50%, #2d1b69 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.login-page::before {\n  content: \"\";\n  position: absolute;\n  width: 500px;\n  height: 500px;\n  background: radial-gradient(circle, rgba(252, 187, 50, 0.12) 0%, transparent 70%);\n  top: -100px;\n  right: -100px;\n  pointer-events: none;\n}\n\n.login-page::after {\n  content: \"\";\n  position: absolute;\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, rgba(124, 19, 202, 0.1) 0%, transparent 70%);\n  bottom: -100px;\n  left: -100px;\n  pointer-events: none;\n}\n\n.login-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 48px 40px;\n  width: 100%;\n  max-width: 440px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);\n  position: relative;\n  z-index: 1;\n  animation: loginSlideUp 0.5s ease-out;\n}\n\n@keyframes loginSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-card .login-logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.login-card .login-logo img {\n  width: 70px;\n  height: 70px;\n  object-fit: contain;\n  margin-bottom: 16px;\n}\n\n.login-card .login-logo h1 {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1e1e5c;\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.login-card .login-logo p {\n  font-size: 13px;\n  color: #888;\n  margin: 0;\n}\n\n.login-card .form-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2c2c3e;\n  margin-bottom: 6px;\n}\n\n.login-card .form-control {\n  background: #f4f6fb !important;\n  border: 1.5px solid #e0e4ed !important;\n  border-radius: 10px !important;\n  padding: 12px 16px;\n  padding-left: 42px !important;\n  /* Ensure enough space for icons by default */\n  font-size: 14px !important;\n  color: #2c2c3e !important;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;\n}\n\n.login-card .form-control:focus {\n  border-color: #1e1e5c !important;\n  box-shadow: 0 0 0 3px rgba(30, 30, 92, 0.1) !important;\n  background: #fff !important;\n}\n\n.login-card .form-control::placeholder {\n  color: #aaa !important;\n  font-size: 13px;\n}\n\n.login-card .login-btn {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #1e1e5c 0%, #2a2a72 100%) !important;\n  border: none !important;\n  border-radius: 10px !important;\n  color: #fff !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  cursor: pointer;\n  transition: all 0.3s ease !important;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-card .login-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(30, 30, 92, 0.35) !important;\n}\n\n.login-card .login-btn:active {\n  transform: translateY(0);\n}\n\n/* ========== CUSTOM SCROLLBAR ========== */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 10px;\n}\n\n.custom-scrollbar:hover::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n/* Sidebar scrollbar */\n.sidebar .sidebar-nav-area::-webkit-scrollbar {\n  width: 4px;\n}\n\n.sidebar .sidebar-nav-area::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar .sidebar-nav-area::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n}\n\n/* ========== BUTTONS ========== */\n.btn-primary-admin {\n  background: linear-gradient(135deg, #1e1e5c 0%, #2a2a72 100%);\n  border: none;\n  border-radius: 10px;\n  padding: 10px 24px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-primary-admin:hover {\n  box-shadow: 0 4px 16px rgba(30, 30, 92, 0.3);\n  transform: translateY(-1px);\n}\n\n.btn-accent {\n  background: linear-gradient(135deg, #FCBB32 0%, #f5a623 100%);\n  border: none;\n  border-radius: 10px;\n  padding: 10px 24px;\n  color: #1e1e5c;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-accent:hover {\n  box-shadow: 0 4px 16px rgba(252, 187, 50, 0.35);\n  transform: translateY(-1px);\n}\n\n/* ========== FORM INPUT ENHANCEMENTS ========== */\n.form-control {\n  border-radius: 8px !important;\n  border: 1.5px solid #e0e4ed !important;\n  padding: 10px 14px !important;\n  font-size: 13.5px !important;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;\n}\n\n.form-control:focus {\n  border-color: #1e1e5c !important;\n  box-shadow: 0 0 0 3px rgba(30, 30, 92, 0.08) !important;\n}\n\n/* ========== TABLE ENHANCEMENTS ========== */\ntable {\n  border-collapse: separate !important;\n  border-spacing: 0;\n  border-radius: 10px !important;\n  overflow: hidden;\n}\n\ntable thead {\n  background: #f4f6fb !important;\n}\n\ntable thead th {\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  color: #6b7280 !important;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 12px 16px !important;\n  border-bottom: 2px solid #e8ecf3 !important;\n}\n\ntable tbody td {\n  padding: 12px 16px !important;\n  font-size: 13.5px;\n  border-bottom: 1px solid #f0f2f7;\n}\n\ntable tbody tr:last-child td {\n  border-bottom: none;\n}\n\ntable tbody tr:hover {\n  background: #f8f9fc;\n}\n\n/* ========== POPPER / DROPDOWN ========== */\n.navbar-profile-popper {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e8ecf3;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);\n  padding: 8px;\n  min-width: 200px;\n}\n\n.navbar-profile-popper .profile-info {\n  padding: 12px 14px;\n  border-bottom: 1px solid #f0f2f7;\n  margin-bottom: 4px;\n}\n\n.navbar-profile-popper .profile-info .profile-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2c2c3e;\n}\n\n.navbar-profile-popper .profile-info .profile-role {\n  font-size: 11px;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.navbar-profile-popper .logout-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  color: #FB325E;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n}\n\n.navbar-profile-popper .logout-btn:hover {\n  background: rgba(251, 50, 94, 0.06);\n}\n\n/* ========== USER AVATAR ========== */\n.user-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #FCBB32 0%, #f5a623 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #1e1e5c;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: box-shadow 0.2s ease;\n}\n\n.user-avatar:hover {\n  box-shadow: 0 0 0 3px rgba(252, 187, 50, 0.25);\n}\n\n/* ========== PAGE TITLE ========== */\n.page-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1e1e5c;\n  margin-bottom: 4px;\n}\n\n.page-subtitle {\n  font-size: 13px;\n  color: #888;\n  margin-bottom: 20px;\n}\n\n/* ========== ANIMATION UTILITIES ========== */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.35s ease-out;\n}\n\n/* ========== RESPONSIVE ========== */\n/* Managed by Tailwind's responsive prefixes (sm:, md:, lg:, xl:, etc.) */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
